// import React from "react";
// import "./index.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Home from "./components/Home";
// import Projects from "./components/Projects/Projects";
// import anime from "animejs";

// function randomValues() {
//   anime({
//     targets: ".square, .circle, .triangle",
//     translateX: function () {
//       return anime.random(-500, 500);
//     },
//     translateY: function () {
//       return anime.random(-300, 300);
//     },
//     rotate: function () {
//       return anime.random(0, 360);
//     },
//     scale: function () {
//       return anime.random(0.2, 2);
//     },
//     duration: 4000,
//     easing: "easeInOutQuad",
//     complete: randomValues,
//   });
// }

// randomValues();

// function App() {

//   return (
//     <div>
//       <>

//         <div className="Backgorund__container">
//           <div class="square"></div>
//           <div class="square"></div>
//           <div class="square"></div>
//           <div class="square"></div>
//           <div class="square"></div>

//           <div class="circle"></div>
//           <div class="circle"></div>
//           <div class="circle"></div>
//           <div class="circle"></div>
//           <div class="circle"></div>

//           <div class="triangle"></div>
//           <div class="triangle"></div>
//           <div class="triangle"></div>
//           <div class="triangle"></div>
//           <div class="triangle"></div>
//         </div>

//       <Router>
//         <Routes>
//           <Route path="/" element={<Home/>} />
//           <Route path="/projects" element={<Projects/>} />
//         </Routes>
//       </Router>

          
      
//       </>
//     </div>
//   );
// }

// export default App;

import React from "react";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Projects from "./components/Projects/Projects";
import AboutPage from "./components/AboutPage/AboutPage";
import anime from "animejs";

function randomValues() {
  anime({
    targets: ".square, .circle, .triangle",
    translateX: function () {
      return anime.random(-500, 500);
    },
    translateY: function () {
      return anime.random(-300, 300);
    },
    rotate: function () {
      return anime.random(0, 360);
    },
    scale: function () {
      return anime.random(0.2, 2);
    },
    duration: 4000,
    easing: "easeInOutQuad",
    complete: randomValues,
  });
}

randomValues();

function App() {

  return (
    <div>
      <>

        <div className="Backgorund__container">
          <div class="square"></div>
          <div class="square"></div>
          <div class="square"></div>
          <div class="square"></div>
          <div class="square"></div>

          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>
          <div class="circle"></div>

          <div class="triangle"></div>
          <div class="triangle"></div>
          <div class="triangle"></div>
          <div class="triangle"></div>
          <div class="triangle"></div>
        </div>

      <Router>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/projects" element={<Projects/>} />
          <Route path="/about" element={<AboutPage/>} />
        </Routes>
      </Router>

          
      
      </>
    </div>
  );
}

export default App;